// ✅ src/screens/AdminScreen.js
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../lib/firebase";
import { doc, getDoc } from "firebase/firestore";

// ✅ Import modules (works if file uses default OR named exports)
import AdminHomeScreenMod from "../components/admin/AdminHomeScreen";
import AdminUsersScreenMod from "../components/admin/AdminUsersScreen";
import AdminReportsScreenMod from "../components/admin/AdminReportsScreen";
import AdminNotificationsScreenMod from "../components/admin/AdminNotificationsScreen";
import AdminPaymentsScreenMod from "../components/admin/AdminPaymentsScreen";
import AdminSupportInboxScreenMod from "../components/admin/AdminSupportInboxScreen";

// ✅ unwrap default if present
const AdminHomeScreen = AdminHomeScreenMod?.default ?? AdminHomeScreenMod;
const AdminUsersScreen = AdminUsersScreenMod?.default ?? AdminUsersScreenMod;
const AdminReportsScreen = AdminReportsScreenMod?.default ?? AdminReportsScreenMod;
const AdminNotificationsScreen =
  AdminNotificationsScreenMod?.default ?? AdminNotificationsScreenMod;
const AdminPaymentsScreen = AdminPaymentsScreenMod?.default ?? AdminPaymentsScreenMod;
const AdminSupportInboxScreen =
  AdminSupportInboxScreenMod?.default ?? AdminSupportInboxScreenMod;

export default function AdminScreen({ goBack }) {
  const nav = useNavigate();

  const [tab, setTab] = useState("home");
  const [role, setRole] = useState("");
  const [loadingRole, setLoadingRole] = useState(true);

  // ✅ ALWAYS have a working back function
  const goBackToSettings = useMemo(() => {
    if (typeof goBack === "function") return goBack; // if parent passed it
    return () => nav("/settings"); // fallback route
  }, [goBack, nav]);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const u = auth.currentUser;

        if (!u) {
          if (alive) {
            setRole("");
            setLoadingRole(false);
          }
          return;
        }

        const snap = await getDoc(doc(db, "stores", u.uid));
        const store = snap.exists() ? snap.data() : null;

        const r = String(store?.role || "").toLowerCase().trim();
        const isAdminBool = store?.isAdmin === true;

        if (!alive) return;
        setRole(isAdminBool ? "admin" : r);
      } catch (e) {
        console.log("ADMIN ROLE LOAD ERROR:", e);
        if (!alive) return;
        setRole("");
      } finally {
        if (alive) setLoadingRole(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  if (loadingRole) return <div style={{ padding: 16 }}>Loading…</div>;

  const backHome = () => setTab("home");

  if (tab === "users") return <AdminUsersScreen goBack={backHome} role={role} />;
  if (tab === "reports") return <AdminReportsScreen goBack={backHome} role={role} />;
  if (tab === "notifications")
    return <AdminNotificationsScreen goBack={backHome} role={role} />;
  if (tab === "payments") return <AdminPaymentsScreen goBack={backHome} role={role} />;
  if (tab === "support") return <AdminSupportInboxScreen goBack={backHome} role={role} />;

  return (
    <AdminHomeScreen
      goBack={goBackToSettings}   // ✅ now it ALWAYS works
      role={role}
      onOpenUsers={() => setTab("users")}
      onOpenReports={() => setTab("reports")}
      onOpenNotifications={() => setTab("notifications")}
      onOpenPayments={() => setTab("payments")}
      onOpenSupport={() => setTab("support")}
    />
  );
}
